/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return truthy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return falsy; });
/* unused harmony export existy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isDefined; });
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isObject */
/* unused harmony export isFunction */
/* unused harmony export isRegExp */
/* unused harmony export not */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNotDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parseInt10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return parseStrIntToInt; });
/* unused harmony export removeElementInArray */
/* unused harmony export allOf */
/* unused harmony export anyOf */
/* unused harmony export getDefined */
/* unused harmony export notSingleEle */
/* unused harmony export each */
/* unused harmony export getFileExtension */
/* unused harmony export getFirstObjectHasProperty */
/* unused harmony export getObjectHasProperty */
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* unused harmony export getResolution */
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* unused harmony export isMobileResolution */
/* unused harmony export numberWithCommas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUriParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUriCombinedParams; });
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* unused harmony export getChangedStats */
/* unused harmony export getPlusElixirPointByLevel */
/* unused harmony export isLevelCanConsumeElixirStat */
/* unused harmony export isLevelGetElixirPoint */
/* unused harmony export getStatMaxByLevel */
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(1);
/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
var getStatMaxByLevel = function getStatMaxByLevel(level, statMaxByLevel) {
  var _statMax = 50;
  each(statMaxByLevel, function (obj) {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_0__model_model__["c" /* PET_NECKLACE_ID */] ? true : false;
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BREAKPOINTS; });
/* unused harmony export DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_DOMAIN_DEFAULT; });
/* unused harmony export API_COMMUNITY_DOMAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATIC_DOMAIN_DEFAULT; });
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatasWithOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleApiError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(8);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingBarTpl; });
var getLoadingBarTpl = function getLoadingBarTpl() {
  return '<div class="loadingbar"></div>';
};



/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ranking_Ranking__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);



(function ($, global) {
  "use strict";

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["f" /* namespace */])('nc.lineage');

  nc.lineage.ranking = function (options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["e" /* isNotDefined */])(options)) throw new Error('nc.lineage.ranking require options object');

    var ranking = new __WEBPACK_IMPORTED_MODULE_0__ranking_Ranking__["a" /* default */](options).init();
  };
})(jQuery, window);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyCharacterRanking__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClassRanking__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_model__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var Ranking = function () {
  function Ranking(options) {
    _classCallCheck(this, Ranking);

    var _ = this;

    _.option = $.extend({
      wrap: null,
      apiDomain: __WEBPACK_IMPORTED_MODULE_4__model_model__["a" /* API_DOMAIN_DEFAULT */],
      staticDomain: __WEBPACK_IMPORTED_MODULE_4__model_model__["d" /* STATIC_DOMAIN_DEFAULT */],
      serverId: 1,
      classCode: 'all', // all : 전체, lord : 군주, knight : 기사, elf : 요정, wizard : 마법사, darkelf : 다크엘프, dragonknight : 용기사, illusionist : 환술사, warrior : 전사, lancer : 창기사, holyknight : 성기사
      isLogin: false,
      global: window
    }, options);

    _.global = _.option.global;

    _.locationParams = null;
    _.classRankingPageIndex = 1;

    _.myCharacterRanking = null;
    _.classRanking = null;
  }

  _createClass(Ranking, [{
    key: 'init',
    value: function init() {
      var _ = this;

      _.locationParams = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["c" /* getUriParams */])(_.global.location.href) || {};
      _.classRankingPageIndex = parseInt(!_.locationParams || !_.locationParams.classRankingPage ? 1 : _.locationParams.classRankingPage, 10);

      _.setMyCharacterRanking();
      _.setClassRanking();

      return _;
    }
  }, {
    key: 'setMyCharacterRanking',
    value: function setMyCharacterRanking() {
      var _ = this,
          opt = _.option;

      _.myCharacterRanking = new __WEBPACK_IMPORTED_MODULE_0__MyCharacterRanking__["a" /* default */]({
        wrap: $('.section-ranking-mycharacter', opt.wrap),
        apiDomain: opt.apiDomain,
        staticDomain: opt.staticDomain,
        serverId: opt.serverId,
        isLogin: opt.isLogin,
        global: _.global
      }).init();
    }
  }, {
    key: 'setClassRanking',
    value: function setClassRanking() {
      var _ = this,
          opt = _.option;

      _.classRanking = new __WEBPACK_IMPORTED_MODULE_1__ClassRanking__["a" /* default */]({
        wrap: $('.section-ranking-list', opt.wrap),
        apiDomain: opt.apiDomain,
        serverId: opt.serverId,
        classCode: opt.classCode,
        pageIndex: _.classRankingPageIndex,
        clickPageBtnCallback: function clickPageBtnCallback(pageIndex) {
          _.global.location.href = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* getUriCombinedParams */])(location.pathname, {
            serverId: opt.serverId,
            classCode: opt.classCode,
            classRankingPage: pageIndex
          });
        },
        global: _.global
      }).init();
    }
  }]);

  return Ranking;
}();

/* harmony default export */ __webpack_exports__["a"] = (Ranking);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_tpl_loadingbar__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_model__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var MyCharacterRanking = function () {
  function MyCharacterRanking(options) {
    _classCallCheck(this, MyCharacterRanking);

    var _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      staticDomain: '',
      serverId: 1,
      isLogin: false,
      global: window
    }, options);

    _.global = _.option.global;

    _.wrap = null;
    _.infoWrap = null;

    _.DISPLAY_CHARACTER_LEVEL_MIN = 60;
  }

  _createClass(MyCharacterRanking, [{
    key: 'init',
    value: function init() {
      var _ = this;

      _.infoWrap = $('.wrap-detail-info', _.option.wrap);

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* falsy */])(_.option.isLogin)) {
        _.infoWrap.remove();

        return _;
      }

      _.setLoadingBar(true);

      _.setData();

      return _;
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _ = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_service__["a" /* getDatasWithOption */])([{
        type: 'GET',
        url: _.option.apiDomain + '/api/world/ranking/' + _.option.serverId + '/mycharacter',
        dataType: 'json',
        xhrFields: { withCredentials: true }

      }], function (data) {
        _.setLoadingBar(false);
        _.setInstance(data);
      }, function (data) {
        if (data.responseJSON.result.errorCode === 'WORLD_RANK_NOT_EXIST_RANKING_SERVER') {
          // no process
        }

        _.setLoadingBar(false);

        _.setCharacters(null);

        Object(__WEBPACK_IMPORTED_MODULE_2__utils_service__["b" /* handleApiError */])(data);
      });
    }
  }, {
    key: 'setInstance',
    value: function setInstance(data) {
      var _ = this;

      _.setDate(data.rankCachedTime);
      _.setCharacters(data.rankCharacterList);

      var itemLength = $('.detail-info .detail-info-list', _.infoWrap).length;
      if (itemLength > 0) {
        $('.wrap-detail-info').show();
        $('.detail-info', _.infoWrap).slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 250,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [{
            breakpoint: Number.MAX_VALUE,
            settings: 'unslick'
          }, {
            breakpoint: __WEBPACK_IMPORTED_MODULE_3__model_model__["b" /* BREAKPOINTS */].pc,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $(_.global).on('resize.ui.mycharacterranking', $.proxy(_.resize, _));
        _.resize();
      } else {
        // no character
      }
    }
  }, {
    key: 'setDate',
    value: function setDate(rankCachedTime) {
      var str = rankCachedTime || '',
          matchArr = str.match(/\d+\.\d+\.\d+\./g);

      if (matchArr && matchArr.length) str = matchArr[0];
      $('.wrap-detail-info .date', this.wrap).text(str);
    }
  }, {
    key: 'setCharacters',
    value: function setCharacters(rankCharacterList) {
      var _ = this;

      if (!rankCharacterList || !Array.isArray(rankCharacterList) || rankCharacterList.length <= 0) {
        $('.wrap-detail-info', _.option.wrap).remove();
        return;
      }

      var tpl = '',
          level = 0,
          gameCharacter = null;
      rankCharacterList.forEach(function (value, index, array) {
        gameCharacter = value.gameCharacter;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* isDefined */])(gameCharacter)) {
          level = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["g" /* parseInt10 */])(gameCharacter.level);

          if (level >= _.DISPLAY_CHARACTER_LEVEL_MIN) {
            tpl += _.getRankItemTpl({
              thumbObj: _.getClassThumbObj(gameCharacter),
              serverName: gameCharacter.serverName,
              characterName: gameCharacter.name,
              characterLevel: gameCharacter.level,
              classRank: value.classRank,
              serverRank: value.serverRank,
              grade: Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* parseStrIntToInt */])(value.grade)
            });
          }
        }
      });

      $('.detail-info .detail-info-list', _.infoWrap).remove();
      $('.detail-info', _.infoWrap).append(tpl);
    }
  }, {
    key: 'getClassThumbObj',
    value: function getClassThumbObj(data) {
      return {
        classId: Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* isDefined */])(data.classId) ? data.classId : 1,
        gender: data.gender === 0 ? 'm' : 'f' // 올초 리니지NP화 때, LineageCharcter로 api 응답이 바뀌면서 gender 가 MALE, FEMALE이 아니라 0(남자), 1(여자)로 응답 되도록 변경된 부분이 있어서 MALE, FEMALE이 아니라 0, 1로 판단하도록 변경되어야 할 것 같습니다.
      };
    }
  }, {
    key: 'getRankItemTpl',
    value: function getRankItemTpl(data) {
      var grade = data.grade,
          classStr = 'grade' + grade;

      if (grade < 0) classStr = 'grade-none';

      var gradeIcon = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* parseStrIntToInt */])(data.serverRank) <= 3 && Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* parseStrIntToInt */])(data.serverRank) > 0 ? 'top' + data.serverRank : '' + classStr;

      var tpl = '<div class="detail-info-list">\n\t\t\t\t\t<dl>\n\t\t\t\t\t\t<dt class="thumb">\n\t\t\t\t\t\t  <img src="' + this.option.staticDomain + '/resource/lineage/profile/char' + data.thumbObj.classId + '_' + data.thumbObj.gender + '.png">\n\t\t\t\t\t\t</dt>\n\t\t\t\t\t\t<dd>\n\t\t\t\t\t\t\t<strong class="name">' + data.characterName + '</strong><span class="server">' + data.serverName + '</span><span class="level">' + data.characterLevel + 'Lv.</span>\n\t\t\t\t\t\t</dd>\n\t\t\t\t\t</dl>\n\t\t\t\t\t<div class="ranking-info">\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li><strong>' + data.serverRank + '</strong><span>\uC11C\uBC84\uB7AD\uD0B9</span></li>\n\t\t\t\t\t\t\t<li><strong>' + data.classRank + '</strong><span>\uD074\uB798\uC2A4\uB7AD\uD0B9</span></li>\n\t\t\t\t\t\t\t<li class="grade"><span class="star ' + gradeIcon + '"></span><span>\uB4F1\uAE09</span></li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>';

      return tpl;
    }
  }, {
    key: 'setLoadingBar',
    value: function setLoadingBar(flag) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["i" /* truthy */])(flag)) {
        $('.detail-info', _.infoWrap).append(Object(__WEBPACK_IMPORTED_MODULE_0__model_tpl_loadingbar__["a" /* getLoadingBarTpl */])());
      } else {
        $('.loadingbar', _.infoWrap).remove();
      }
    }
  }, {
    key: 'resize',
    value: function resize(evt) {
      $('.detail-info', this.infoWrap).slick('resize');
    }
  }]);

  return MyCharacterRanking;
}();

/* harmony default export */ __webpack_exports__["a"] = (MyCharacterRanking);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_tpl_loadingbar__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_msg_board__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var ClassRanking = function () {
  function ClassRanking(options) {
    _classCallCheck(this, ClassRanking);

    var _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      serverId: 1,
      classCode: 'all',
      pageIndex: 1,
      clickPageBtnCallback: null,
      global: window
    }, options);

    _.wrap = $(_.option.wrap);

    _.currentPage = 1;

    _.msg = {
      NO_ITEM: '랭킹 정보가 없습니다.',
      NO_SUPPORT: '랭킹 정보를 제공하지 않는 서버입니다.'
    };
  }

  _createClass(ClassRanking, [{
    key: 'init',
    value: function init() {
      var _ = this;

      if (_.wrap.length) {
        _.currentPage = _.option.pageIndex >= 1 ? _.option.pageIndex : 1;

        if (_.option.serverId == 100 || _.option.serverId == 200 || _.option.serverId == 201) {
          _.setLoadingBar(false);
          _.displayError('NO_SUPPORT');
          return;
        } else {
          _.setLoadingBar(true);
          _.setData();
        }
      }

      return _;
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _ = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_service__["a" /* getDatasWithOption */])([{
        type: 'GET',
        url: _.option.apiDomain + '/api/world/ranking/' + _.option.serverId + '/' + _.option.classCode + '/list',
        dataType: 'json',
        data: {
          page: _.currentPage
        }

      }], function (data) {
        _.setLoadingBar(false);
        _.setInstance(data);
      }, function (data) {
        _.setLoadingBar(false);

        if (data.responseJSON.result.errorCode === 'WORLD_RANK_NOT_EXIST_RANKING_SERVER') {
          _.displayError('NO_SUPPORT');
        } else {
          _.displayError('RETRY_LATER');
        }
      });
    }
  }, {
    key: 'setInstance',
    value: function setInstance(data) {
      var _ = this;

      _.setDate(data.rankCachedTime);
      _.setList(data);
    }
  }, {
    key: 'setDate',
    value: function setDate(rankCachedTime) {
      $('header .date', this.wrap).text(rankCachedTime || '');
    }
  }, {
    key: 'setList',
    value: function setList(data) {
      var _ = this;

      if (!data || !Array.isArray(data.rankList) || data.rankList.length <= 0) {
        _.displayError('NO_ITEM');
        return;
      }

      var tpl = '',
          rankChangeObj = null;
      data.rankList.forEach(function (value, index, array) {
        rankChangeObj = _.getRankChangeObj(value.rankChange);

        tpl += _.getRankItemTpl({
          rank: value.rank,
          serverRank: value.serverRank,
          rankChange: rankChangeObj.change,
          rankUpDown: rankChangeObj.updown,
          characterName: value.characterName,
          className: value.className,
          grade: Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["h" /* parseStrIntToInt */])(value.grade)
        });
      });

      $('.table-list tbody', _.wrap).empty().append(tpl);

      _.setPagination(data.pagination);

      _.currentPage = data.pagination.currentPage;
    }
  }, {
    key: 'setPagination',
    value: function setPagination(data) {
      var _ = this,
          tpl = _.getPaginationTpl(data);

      $('.pagination', _.wrap).empty().append(tpl);

      $('.btn.prev', _.wrap).on('click', function (evt) {
        var pageIndex = _.currentPage < 1 ? 1 : _.currentPage - 1;
        _.option.clickPageBtnCallback.apply(null, [pageIndex]);
      });

      $('.btn.next', _.wrap).on('click', function (evt) {
        var pageIndex = _.currentPage >= data.maxPageNo ? data.maxPageNo : _.currentPage + 1;
        _.option.clickPageBtnCallback.apply(null, [pageIndex]);
      });
    }
  }, {
    key: 'getRankItemTpl',
    value: function getRankItemTpl(data) {
      var _ = this;
      var gradeIcon = Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["h" /* parseStrIntToInt */])(data.serverRank) <= 3 && Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["h" /* parseStrIntToInt */])(data.serverRank) > 0 ? 'top' + data.serverRank : 'grade' + data.grade;
      var gradeStr = data.grade <= 0 ? '-' : '&nbsp;';

      var tpl = '<tr>\n      <td class="rank"><span class="num">' + data.rank + '</span><span class="ui-rank ' + data.rankUpDown + '">' + data.rankChange + '</span></td>\n      <td>' + data.characterName + '</td>\n      <td>' + data.className + '</td>\n      <td class="grade"><span class="star ' + gradeIcon + '">' + gradeStr + '</span></td>\n    </tr>';

      return tpl;
    }
  }, {
    key: 'getRankChangeObj',
    value: function getRankChangeObj(number) {
      var obj = { change: '-', updown: '' };

      if (number > 0) {
        obj.change = number;
        obj.updown = 'up';
      } else if (number < 0) {
        obj.change = number;
        obj.updown = 'down';
      }

      return obj;
    }
  }, {
    key: 'getRankUpDownStr',
    value: function getRankUpDownStr(number) {
      var str = '';

      if (number > 0) {
        str = 'up';
      } else if (number < 0) {
        str = 'down';
      }

      return str;
    }
  }, {
    key: 'getPaginationTpl',
    value: function getPaginationTpl(data) {
      var DISABLED_STR = 'disabled="disabled"';

      var prevBtn = '<button class="btn prev" ' + (!data.previous ? DISABLED_STR : '') + '>\uC774\uC804</button>',
          pageBtns = '<span class="page">\n                    <strong>' + data.start + '-' + data.end + '</strong> / ' + data.totalCount + '\n                  </span>',
          nextBtn = '<button class="btn next" ' + (!data.next ? DISABLED_STR : '') + '>\uB2E4\uC74C</button>';

      return '' + prevBtn + pageBtns + nextBtn;
    }
  }, {
    key: 'setLoadingBar',
    value: function setLoadingBar(flag) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["i" /* truthy */])(flag)) {
        $('.table-list', _.wrap).append(Object(__WEBPACK_IMPORTED_MODULE_0__model_tpl_loadingbar__["a" /* getLoadingBarTpl */])());
      } else {
        $('.loadingbar', _.wrap).remove();
      }
    }
  }, {
    key: 'displayError',
    value: function displayError(code) {
      var _ = this;

      $('.table-list', _.wrap).hide();
      $('.pagination', _.wrap).hide();

      switch (code) {
        case 'NO_ITEM':
          _.wrap.append('<div class="nodata"><p>' + _.msg.NO_ITEM + '</p></div>');
          break;

        case 'RETRY_LATER':
          _.wrap.append('<div class="nodata"><p>' + __WEBPACK_IMPORTED_MODULE_3__model_msg_board__["a" /* BOARD */].RETRY_LATER + '</p></div>');
          break;

        case 'NO_SUPPORT':
          _.wrap.append('<div class="nodata"><p>' + _.msg.NO_SUPPORT + '</p></div>');
          break;

      }
    }
  }]);

  return ClassRanking;
}();

/* harmony default export */ __webpack_exports__["a"] = (ClassRanking);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOARD; });
// TODO - disassemble
var BOARD = {
  NO_ITEM: '등록된 글이 없습니다.',
  RETRY_LATER: '잠시 후 다시 시도해주세요.'
};



/***/ })
/******/ ]);


// WEBPACK FOOTER //
// world/ranking.js